import { cva, type VariantProps } from "cva";

export const heroStyles = cva({
  base: "w-full",
  variants: {
    layout: {
      center: "flex flex-col gap-y-xl items-center text-center",
      left: "flex flex-col gap-y-xl items-start text-left",
      split: "flex flex-col gap-y-xl lg:grid lg:grid-cols-2 lg:gap-x-2xl lg:items-start",
    },
  },
});

export const heroContentStyles = cva({
  base: "flex flex-col gap-y-sm w-full",
  variants: {
    layout: {
      center: "items-center",
      left: "items-start",
      split: "items-start",
    },
  },
});

export const heroHeadlineStyles = cva({
  base: "",
  variants: {
    layout: {
      center: null,
      left: null,
      split: "lg:max-w-none",
    },
  },
});

export const heroBodyStyles = cva({
  base: "w-full md:max-w-600 lg:max-w-800",
  variants: {
    layout: {
      center: null,
      left: null,
      split: "lg:max-w-none",
    },
  },
});

export const heroActionsStyles = cva({
  base: "flex w-full flex-col gap-y-sm sm:w-auto sm:flex-row sm:items-center sm:gap-x-sm sm:gap-y-0",
  variants: {
    layout: {
      center: "items-center sm:justify-center",
      left: "items-stretch sm:justify-start",
      split: "items-stretch sm:justify-start",
    },
  },
});

export type HeroVariantProps = VariantProps<typeof heroStyles>;
